import { PublicHolidayRecord } from './types';

export const us: PublicHolidayRecord[] = [
  {
    name: 'Labor Day',
    date: new Date('2026-09-07'),
  },
  {
    name: 'Thanksgiving Day',
    date: new Date('2026-11-26'),
  },
  {
    name: 'Christmas Day',
    date: new Date('2026-12-25'),
  },
  {
    name: "New Year's Day",
    date: new Date('2027-01-01'),
  },
  {
    name: 'Memorial Day',
    date: new Date('2027-05-31'),
  },
  {
    name: 'Independence Day',
    date: new Date('2027-07-04'),
  },
  {
    name: 'Labor Day',
    date: new Date('2027-09-06'),
  },
  {
    name: 'Thanksgiving Day',
    date: new Date('2027-11-25'),
  },
  {
    name: 'Christmas Day',
    date: new Date('2027-12-25'),
  },
  {
    name: "New Year's Day",
    date: new Date('2028-01-01'),
  },
  {
    name: 'Memorial Day',
    date: new Date('2028-05-29'),
  },
  {
    name: 'Independence Day',
    date: new Date('2028-07-04'),
  },
  {
    name: 'Labor Day',
    date: new Date('2028-09-04'),
  },
  {
    name: 'Thanksgiving Day',
    date: new Date('2028-11-23'),
  },
  {
    name: 'Christmas Day',
    date: new Date('2028-12-25'),
  },
  {
    name: "New Year's Day",
    date: new Date('2029-01-01'),
  },
  {
    name: 'Memorial Day',
    date: new Date('2029-05-28'),
  },
  {
    name: 'Independence Day',
    date: new Date('2029-07-04'),
  },
  {
    name: 'Labor Day',
    date: new Date('2029-09-03'),
  },
  {
    name: 'Thanksgiving Day',
    date: new Date('2029-11-22'),
  },
  {
    name: 'Christmas Day',
    date: new Date('2029-12-25'),
  },
  {
    name: "New Year's Day",
    date: new Date('2030-01-01'),
  },
  {
    name: 'Memorial Day',
    date: new Date('2030-05-27'),
  },
  {
    name: 'Independence Day',
    date: new Date('2030-07-04'),
  },
  {
    name: 'Labor Day',
    date: new Date('2030-09-02'),
  },
  {
    name: 'Thanksgiving Day',
    date: new Date('2030-11-28'),
  },
  {
    name: 'Christmas Day',
    date: new Date('2030-12-25'),
  },
  {
    name: "New Year's Day",
    date: new Date('2031-01-01'),
  },
  {
    name: 'Memorial Day',
    date: new Date('2031-05-26'),
  },
  {
    name: 'Independence Day',
    date: new Date('2031-07-04'),
  },
  {
    name: 'Labor Day',
    date: new Date('2031-09-01'),
  },
  {
    name: 'Thanksgiving Day',
    date: new Date('2031-11-27'),
  },
  {
    name: 'Christmas Day',
    date: new Date('2031-12-25'),
  },
];
